import { REGULAR_TIER, UNLIMITED_TIER } from "@chesshotel/constants";
import { useMembership } from "../ducks/membership";

export default function PlayWire({ className, id, contStyles = "" }) {
  const { tier } = useMembership();

  if (tier === REGULAR_TIER || tier === UNLIMITED_TIER) {
    return null;
  }

  return (
    <div className={`flex flex-col items-center justify-center ${contStyles}`}>
      <div id={id} className={className}></div>
    </div>
  );
}
